import React, { Fragment } from 'react';
import { ButtonGroup } from '../ButtonGroup/ButtonGroup.es.js';
import { Text } from '../Text/Text.es.js';
import '../MaestroThemeProvider/MaestroThemeProvider.es.js';
import { ColorMode } from '../MaestroThemeProvider/ColorMode.es.js';
import '../MaestroThemeProvider/ExperimentalProvider/ExperimentalProvider.es.js';
import { FloatingActionMenu as FloatingActionMenu$1 } from './styled.es.js';

var FloatingActionMenu = function FloatingActionMenu(_ref) {
  var children = _ref.children,
      title = _ref.title,
      actions = _ref.actions;
  return (
    /* @__PURE__ */
    React.createElement(ColorMode, {
      mode: "light"
    },
    /* @__PURE__ */
    React.createElement(FloatingActionMenu$1, null, children, title &&
    /* @__PURE__ */
    React.createElement(Text, {
      style: {
        whiteSpace: "nowrap"
      }
    }, title), actions &&
    /* @__PURE__ */
    React.createElement(ButtonGroup, {
      spacing: "xs",
      sx: {
        marginLeft: "md"
      }
    }, actions.map(function (action, i) {
      return (
        /* @__PURE__ */
        React.createElement(Fragment, {
          key: i
        }, action)
      );
    }))))
  );
};

FloatingActionMenu.displayName = "FloatingActionMenu";
export { FloatingActionMenu };